export const USER_TYPE_ENUM = {
	drivers: 'drivers',
	nonDrivers: 'nonDrivers',
};
